export default __webpack_public_path__ + "static/media/330_store04-jp-web.c7c73d31.png";